var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4915 43.7288C28.6525 43.7288 27.9343 43.419 27.3369 42.7994C26.7394 42.1798 26.4407 41.435 26.4407 40.5649C26.4407 39.6949 26.7394 38.9501 27.3369 38.3305C27.9343 37.7109 28.6525 37.4011 29.4915 37.4011C30.3305 37.4011 31.0487 37.7109 31.6462 38.3305C32.2436 38.9501 32.5424 39.6949 32.5424 40.5649C32.5424 41.435 32.2436 42.1798 31.6462 42.7994C31.0487 43.419 30.3305 43.7288 29.4915 43.7288ZM29.4915 34.2373C28.6525 34.2373 27.9343 33.9275 27.3369 33.3079C26.7394 32.6883 26.4407 31.9435 26.4407 31.0734V18.4181C26.4407 17.548 26.7394 16.8032 27.3369 16.1836C27.9343 15.564 28.6525 15.2542 29.4915 15.2542C30.3305 15.2542 31.0487 15.564 31.6462 16.1836C32.2436 16.8032 32.5424 17.548 32.5424 18.4181V31.0734C32.5424 31.9435 32.2436 32.6883 31.6462 33.3079C31.0487 33.9275 30.3305 34.2373 29.4915 34.2373Z",
    fill: "#034CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation60);
export default __webpack_public_path__ + "static/media/exclamation_60.7f43b155cb3571fe9c07d3ee02513846.svg";
export { ForwardRef as ReactComponent };